/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const FlutterWave = ({ Amount, attributes }) => {
    const { setPaymentLoading } = useContext(MyContext);

    const navigate = useNavigate();

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const loadFlutterwaveScript = async () => {
        const script = document.createElement('script');
        script.src = "https://checkout.flutterwave.com/v3.js";
        script.async = true;

        script.onload = () => {
            setIsScriptLoaded(true);
        };

        script.onerror = () => {
            console.error("Failed to load Flutterwave script.");
        };
        document.body.appendChild(script);
    };

    useEffect(() => {
        loadFlutterwaveScript();
    }, []);

    const handlePayment = () => {

        secureLocalStorage.setItem("Amount", Amount);
        setPaymentLoading(false);

        if (!isScriptLoaded) {
            console.error('Flutterwave script is not loaded.');
            return;
        }

        const localData = secureLocalStorage.getItem("LoginData");

        if (!localData) return;
        const parsedData = JSON.parse(localData);

        const paymentOptions = {
            tx_ref: Date.now(),
            amount: Amount,
            currency: 'USD',
            email: parsedData.email,
            phone_number: parsedData.mobile,
            public_key: attributes.split(",")[1],
            callback: (data) => {
                if (data.status === 'successful') {
                    sessionStorage.setItem("Paymentstatus", "PaymentDone");
                    sessionStorage.setItem("transactionid", data.transaction_id);
                } else {
                    sessionStorage.setItem("Paymentstatus", "PaymentFaild");
                }
                navigate(0);
            },
            onClose: () => {
                sessionStorage.setItem("Paymentstatus", "Payment Failed.!!");
            },
            customer: {
                email: parsedData.email,
                phone_number: parsedData.mobile,
            },
        };

        if (window.FlutterwaveCheckout) {
            window.FlutterwaveCheckout(paymentOptions);
        } else {
            console.error('FlutterwaveCheckout function is not available.');
        }
    };

    useEffect(() => {
        if (isScriptLoaded && Amount) {
            handlePayment();
        }
    }, [isScriptLoaded, Amount]);

    return null;
};

export default FlutterWave;
/* jshint ignore:end */